'use client';

import Icon from './Icon';
import svg from 'sprites/cross.svg';

export default function IconCross({
  className = 'w-2 h-2 stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
